import React from 'react'
import SbEditable from 'storyblok-react'

import CheckIcon from './../../graphics/check.svg'

import styles from './styles.module.scss'

const List = (props) => {
    return (
        <SbEditable content={props.blok}>
            <ul className={styles['list']}>
                {props.blok.items && props.blok.items.map(({ text }, i) => 
                    <li key={i} className={styles['list-item']}>
                        <div className={styles['list-item__icon-wrapper']}>
                            <CheckIcon className={styles['list-item__icon']} />
                        </div>
                        <p className={`heading-6 ${styles['list-item__label']}`}>{text}</p>
                    </li>
                )}
            </ul>
        </SbEditable>
    )
}

export default List
